import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const UpgradePrompt = ({ onUpgrade }) => {
  const premiumFeatures = [
    {
      icon: 'Zap',
      title: 'Real-time Signals',
      description: 'Get instant trading alerts'
    },
    {
      icon: 'TrendingUp',
      title: 'AI Predictions',
      description: 'Advanced market forecasting'
    },
    {
      icon: 'PieChart',
      title: 'Portfolio Analytics',
      description: 'Detailed performance insights'
    },
    {
      icon: 'MessageCircle',
      title: 'Priority Support',
      description: '24/7 expert assistance'
    }
  ];

  return (
    <div className="w-full max-w-md mx-auto mt-8">
      <div className="bg-gradient-to-br from-primary/5 to-secondary/5 border border-primary/20 rounded-lg p-6">
        <div className="text-center mb-4">
          <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center mx-auto mb-3">
            <Icon name="Crown" size={24} color="white" />
          </div>
          <h3 className="text-lg font-semibold text-foreground mb-2">Unlock Premium Features</h3>
          <p className="text-sm text-muted-foreground">
            Get access to advanced AI predictions and professional trading tools
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 mb-6">
          {premiumFeatures?.map((feature, index) => (
            <div key={index} className="flex items-start space-x-2">
              <Icon name={feature?.icon} size={16} className="text-primary mt-0.5" />
              <div>
                <h4 className="text-xs font-medium text-foreground">{feature?.title}</h4>
                <p className="text-xs text-muted-foreground">{feature?.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="space-y-3">
          <Button
            variant="default"
            size="sm"
            fullWidth
            onClick={() => window.location.href = '/subscription-management'}
          >
            <div className="flex items-center justify-center space-x-2">
              <Icon name="Sparkles" size={16} />
              <span>Upgrade to Pro</span>
            </div>
          </Button>
          
          <div className="text-center">
            <p className="text-xs text-muted-foreground">
              Starting at $29/month • Cancel anytime
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradePrompt;